const UPDATES = [
  { date: '07.31', title: '《流浪地球3》高清上线', type: '新片' },
  { date: '07.30', title: '《庆余年2》全集更新完毕', type: '更新' },
  { date: '07.29', title: '《鱿鱼游戏2》中字版上线', type: '新片' },
  { date: '07.28', title: '豆瓣9.4《漫长的季节》上线', type: '推荐' },
  { date: '07.27', title: '《封神第二部》抢先版更新', type: '新片' },
  { date: '07.26', title: '暑期动漫专题重磅上线', type: '专题' },
  { date: '07.25', title: '《三体》电视剧全集上线', type: '新片' },
  { date: '07.24', title: '经典港片修复版合集更新', type: '合集' },
  { date: '07.23', title: '《奥本海默》4K版上线', type: '新片' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-3 whitespace-nowrap">
            最新上架
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            内容更新动态
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            每日滚动更新，热门影视第一时间上线
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {UPDATES.map((item, i) => (
              <div key={i} className="relative mb-6 last:mb-0">
                <div className="absolute -left-[33px] top-0 w-[14px] h-[14px] rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="flex items-start gap-3">
                  <span className="flex-shrink-0 text-xs font-semibold text-primary-600 bg-primary-50 px-2.5 py-1 rounded-md whitespace-nowrap">
                    {item.date}
                  </span>
                  <div>
                    <div className="flex items-center gap-2 flex-wrap">
                      <h3 className="text-sm md:text-base font-semibold text-foreground-900">
                        {item.title}
                      </h3>
                      <span className="px-2 py-0.5 text-xs font-medium bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                        {item.type}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}